export default "https://d1e6s5z4lzmgxx.cloudfront.net/3cbd492b-c681-4587-ab2f-cab322978701/images/go-icon.svg?d23a4b881abf2128ae246ab1ef33636a";